import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          maxHeight="667px"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyStart
          alignCenter
        >
          <CFView textCenter w="92%" mt="5vh" ml="5px">
            <CFImage
              w="100%"
              src={mobileHeroText}
              alt="Got Pho Vietnamese hero text"
              zIndex={98}
            />
            <CFView mt="-75px" mb="0" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          m="0 auto"
          maxWidth="1400px"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignCenter ml="65px" mb="80px">
            <CFImage
              h="70vh"
              maxHeight="520px"
              src={heroText}
              alt="Got Pho Vietnamese hero text"
            />
            <CFView mt="-16vh" pulsate zIndex={98}>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
